
<div class="h-100 w-100 m-0 row bg-custom-primary">
    <div class="col-md-7 flex flex-row-1 form-container px-4 py-3">
        <div class="d-flex justify-content-between">
            <div class="logo">
                <img [src]="cvaUI_url+ '/assets/images/logo.svg'" alt="logo" width="70px">
            </div>
        </div>
       <div class="login-form-wrapper d-flex justify-content-center align-items-center">
        <form [formGroup]="loginForm" (ngSubmit)="submitForm()" class="login-form w-100">
            <div class="text-center mb-4">
                <h1 class="fs-2 fw-normal mb-2">Welcome Back</h1>
                <span class="mb-4">Log into your account</span>
            </div>
          <div class="form-input">
            <mat-form-field  appearance="outline" class="">
                <mat-label>Email</mat-label>
                <input type="text" matInput placeholder="" formControlName="email">
                <mat-error *ngIf="loginForm.get('email')?.dirty && loginForm.get('email')?.hasError('email')">Email is Invalid.</mat-error>
                <mat-error *ngIf="loginForm.get('email')?.dirty && loginForm.get('email')?.hasError('required')">Email is required.</mat-error>
            </mat-form-field>
           
          </div>
           <div class="form-input">
            <mat-form-field  appearance="outline" class="">
                <mat-label>Password</mat-label>
                <input [type]=" passwordVisible ? 'text' : 'password'" matInput placeholder="" formControlName="password">
                <mat-error *ngIf="loginForm.invalid && (loginForm.get('password')?.dirty || loginForm.get('password')?.touched )">
                    <span *ngIf="loginForm.get('password')?.hasError('required')">Password is required.</span>
                    <span *ngIf="loginForm.get('password')?.hasError('minlength')">Password needs to be at least 4 characters long.</span>
                </mat-error>
                <mat-icon matSuffix  (click)="setInputType()" onKeyDown="doNothing();" tabindex="0"
                >{{!passwordVisible ? 'visibility' : 'visibility_off'}}</mat-icon>
            </mat-form-field>
            <mat-error class="custom-error" *ngIf="errMsg">{{errMsg}}</mat-error>
           </div>
           <div class="login-rm-fp-wrapper d-flex justify-content-between">
            <span [routerLink]="['/'+routes_constants.PRACTICE_SIGNUP]" class="fp-label">Don't have an account?
                Sign up</span>
            <span [routerLink]="['/'+routes_constants.FORGOT_PASSWORD]" class="fp-label">Forgot Password?</span>
       </div>
          <div class="mt-4">
            <button class="form-btn" mat-stroked-button type="submit">Log In</button>
          </div>
         <div class="mt-4 d-flex justify-content-center tnc">
            <a class="me-1" [href]="TnC_ROUTE" target="_blank" rel="noopener noreferrer">Terms</a>
            <span>and</span>
            <a class="ms-1" [href]="PRIVACY_POLICY_ROUTE" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
         </div>
        </form>
       </div>
    </div>
    <div class="h-100 col-md-5 bg-cover position-relative bg-co d-none d-md-block">
        <cva-form-template></cva-form-template>
    </div>
</div>